export let SERVER_PATH = "https://api.sdnetworks.kr/partner";
export let SERVER_PATH_DEV = "http://api.www.sdnetworks.kr/partner";
export let CLOUD_ATTENDANCE_URL = "http://api.smilepass.co.kr/cloud_records";
export let RFID_ATTENDANCE_URL = "http://api.smilepass.co.kr/rfid_records";
export let PAYMENT_URL = "http://www.smilepass.co.kr/partner/payment";
export let CHARGE_PAYMENT_URL = "http://www.smilepass.co.kr/partner/charge";
export let CLOUD_SERVER_IP = "52.78.85.16";
export let CLOUD_SERVER_PORT = "5000";
export let SMS_COST = 9;
export let LMS_COST = 26;
export let BANK_ACCOUNT = "기업은행 931-029608-01-010 (주)에스디네트웍스";
export let AGREEMENT_HTML = `
<p>제1조(목적)</p>
<p>이 약관은 (주)에스디네트웍스(이하 "회사")에서 제공하는 파트너시스템에 대한 제반 서비스(이하 "서비스")에 접속과 사용자에 의해서 업로드 및 다운로드 되어 표시되는 모든 정보, 텍스트, 이미지 및 기타 자료를 이용하는 이용자(이하 "회원")와 서비스 이용에 관한 권리 및 의무와 책임사항, 기타 필요한 사항을 규정하는 것을 목적으로 합니다.</p>
<p>&nbsp;</p>
<p>제2조(정의)</p>
<p>이 약관에서는 용어를 다음과 같이 정의하여 사용합니다.</p>
<p>① &ldquo;서비스&rdquo; : 파트너시스템 앱에서 회원이 운영하는 운동시설의 고객관리 서비스를 지원하는 각종 서비스</p>
<p>② &ldquo;회원&rdquo; : 본 약관에 동의하여 회사와 서비스 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 모든 사용자</p>
<p>③ &ldquo;고객&rdquo; : 회원이 서비스를 이용하여 발송한 메시지와 쿠폰을 수신 받는 자</p>
<p>④ &ldquo;이용계약&rdquo; : 서비스를 제공 받기 위하여 회사와 회원 간에 체결하는 계약으로, SD네트웍스 서비스에서 신청하고 파트너시스템을 설치 및 로그인하여 이 약관에 동의한 경우 계약이 성립됨</p>
<p>⑤ &ldquo;아이디&rdquo; : 회원 식별과 회원의 서비스 이용을 위하여 회사가 부여한 문자 및 숫자의 조합</p>
<p>⑥ &ldquo;비밀번호&rdquo; : 회원의 동일성 확인과 회원의 권익 및 비밀 보호를 위하여 부여한 문자 및 숫자의 조합으로 최초 1회만 회사가 부여하며 회원이 수정하여 사용</p>
<p>⑦ &ldquo;문자메시지&rdquo; : 정보통신망을 통해 수신자에게 발송되는 메시지(이하 &ldquo;메시지&rdquo;)</p>
<p>⑧ &ldquo;할인쿠폰&rdquo; : 에스디몰에서 사용할 수 있는 쿠폰</p>
<p>⑨ &ldquo;추천코드&rdquo; : 스마일패스 이용자가 입력하여 보상을 받을 수 있는 고유 코드</p>
<p>⑩ &ldquo;캐시&rdquo; : 회원이 서비스 이용을 위해 구매하는 회사가 지정한 전자지급수단</p>
<p>&nbsp;</p>
<p>제3조(약관의 명시와 개정)</p>
<p>① 회사는 서비스의 메인 페이지에 본 약관을 게시합니다.</p>
<p>② 회사는 관련법에 위배 되지 않는 범위에서 본 약관을 변경할 수 있습니다. 약관이 변경될 경우 회사는 회원에게 7일 전에 서비스 페이지에 이를 공지하고, 사용자에게 전자우편으로 통보합니다.</p>
<p>③ 회원은 회사가 전항에 따라 변경하는 약관에 동의하지 않을 권리가 있으며, 이 경우 회원은 회사에서 제공하는 안내에 따라 서비스 이용중단 의사를 표시하고 서비스 이용종료를 요청할 수 있습니다. 다만, 회사가 회원에게 변경된 약관의 내용을 통보한 후, 회원이 7일 이내 의사표시를 하지 않을 경우 회원이 변경된 약관에 동의하는 것으로 봅니다.</p>
<p>&nbsp;</p>
<p>제4조(약관의 해석과 예외 준칙)</p>
<p>① 회사는 제공하는 개별 서비스에 대해서 별도의 이용약관 및 정책을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우 개별 서비스의 이용약관을 우선하여 적용합니다.</p>
<p>② 본 약관에 명시되지 않은 사항이 관계법령에 규정되어 있을 경우에는 그 규정에 따릅니다.</p>
<p>&nbsp;</p>
<p>제5조(이용계약의 성립)</p>
<p>① 이용계약은 서비스 이용을 신청한 회원이 아이디와 비밀번호를 부여받아 처음 로그인을 할 때 서비스 이용약관에 동의함으로써 체결됩니다.</p>
<p>② 회사는 회원에 대해 회사정책에 따라 등급을 구분하여 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.</p>
<p>③ 회원은 회원가입 시 기재한 개인정보의 내용에 변경이 발생한 경우, 즉시 변경사항을 정정하여 기재하여야 합니다. 변경의 지체로 인하여 발생한 회원의 손해에 대해 회사는 책임을 지지 않습니다.</p>
<p>④ 회사는 관련 법률 및 회사의 개인정보취급방침에서 정한 바에 따라 회원에게 요청하는 회원정보 및 기타정보 항목을 추가, 삭제 등 변경하여 수집 및 이용할 수 있습니다.</p>
<p>&nbsp;</p>
<p>제6조(개인정보보호 의무)</p>
<p>① 회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보취급방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보취급방침이 적용되지 않습니다.</p>
<p>② 회사는 서비스를 중단하거나 회원이 개인정보 제공 동의를 철회한 경우에는 신속하게 회원의 개인정보를 파기합니다. 단, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관련 법률에서 정하는 바에 따라 일정 정보는 보관할 수 있습니다.</p>
<p>③ 회사는 서비스 개선 및 회원 대상의 서비스 소개 등의 목적으로 회원의 동의 하에 관계 법령에서 정하는 바에 따라 추가적인 개인정보를 수집할 수 있습니다.</p>
<p>④ 회사는 법률에 특별한 규정이 있는 경우를 제외하고는 회원의 별도 동의 없이 회원의 계정정보를 포함한 일체의 개인정보를 제3자에게 공개하거나 제공하지 않습니다.</p>
<p>&nbsp;</p>
<p>제7조(회원의 아이디 및 비밀번호)</p>
<p>① 회원은 아이디와 비밀번호에 관해서 관리책임이 있습니다.</p>
<p>② 회원은 아이디 및 비밀번호를 제3자가 이용하도록 제공하면 안 됩니다.</p>
<p>③ 회사는 회원이 아이디 및 비밀번호를 소홀히 관리하여 발생하는 손해, 또는 회사의 과실이 없는 제3자의 부정이용 등으로 인한 손해에 대해 책임을 지지 않습니다.</p>
<p>④ 회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.</p>
<p>&nbsp;</p>
<p>제8조(회사의 의무)</p>
<p>① 회사는 안정적인 서비스의 제공을 위하여 최선을 다하여 노력합니다.</p>
<p>② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 현재 인터넷 보안기술의 발전 수준과 회사가 제공하는 서비스의 성격에 적합한 보안시스템을 갖추고 운영해야 합니다.</p>
<p>③ 회사는 서비스를 이용하는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정 될 경우 이를 처리해야 합니다. 이때 처리 과정에 대해서 고객에게 게시판 답변, 전화연락, SMS 등의 방법으로 전달합니다.</p>
<p>④ 회사는 정보통신망 이용촉진 및 정보보호에 관한 법률, 통신비밀보호법, 전기통신사업법 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.</p>
<p>&nbsp;</p>
<p>제9조(회원의 의무)</p>
<p>① 회원은 다음 각호에 해당하는 행위를 해서는 안 됩니다.</p>
<ol>
<li>이용 신청 또는 회원정보 변경 시 허위내용 등록</li>
<li>타인의 정보 도용</li>
<li>회사의 운영자, 임직원, 회사를 사칭하는 경우</li>
<li>회사가 게시한 정보의 변경</li>
<li>회사와 기타 제3자의 저작권, 영업비밀, 특허권 등 지적재산권에 대한 침해</li>
<li>회사 및 기타 제3자를 희롱하거나, 위협하거나 명예를 손상시키는 행위</li>
<li>외설, 폭력적인 메시지, 기타 공서양속에 반하는 정보를 공개, 전송 또는 게시하는 행위</li>
<li>해킹을 통해서 다른 사용자의 정보를 취득하는 행위</li>
<li>기타 현행 법령에 위반되는 불법적인 행위</li>
</ol>
<p>② 회사는 회원이 전항에서 금지한 행위를 하는 경우, 위반 행위의 경중에 따라 서비스의 이용정지/계약의 해지 등 서비스 이용 제한, 수사 기관에의 고발 조치 등 합당한 조치를 취할 수 있습니다.</p>
<p>③ 회원은 회사의 명시적 사전 동의가 없는 한 서비스의 이용권한 및 기타 이용계약상의 지위를 제3자에게 양도, 증여, 대여할 수 없으며 이를 담보로 제공할 수 없습니다.</p>
<p>④ 회원은 관계법, 이 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.</p>
<p>⑤ 회원은 회사의 사전 허락 없이 회사가 정한 이용 목적과 방법에 반하여 영업/광고활동 등을 할 수 없고, 회원의 서비스 이용이 회사의 재산권, 영업권 또는 비즈니스 모델을 침해하면 안 됩니다.</p>
<p>&nbsp;</p>
<p>제10조(서비스의 제공 및 변경)</p>
<p>① 회사는 회원에게 아래와 같은 서비스를 제공합니다.</p>
<ol>
<li>스마일패스에 회원의 추천코드를 입력한 경우 보상 지급</li>
<li>회원의 시설에 등록된 고객에게 문자 메시지 발송</li>
<li>회원의 시설에 등록된 고객에게 회사에서 제공하는 쿠폰 발행</li>
<li>기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
</ol>
<p>② 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</p>
<p>③ 회사는 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 회원에게 공지사항 게시판 및 SMS 등의 방법으로 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</p>
<p>④ 회사는 회원과 별도로 계약을 체결하여 명시적인 권리를 부여하지 아니하는 한, 회원에게 회사의 상호, 상표, 로고, 도메인 네임 및 기타 식별력 있는 브랜드 특성을 이용할 수 있는 권리를 부여하지 않습니다.</p>
<p>⑤ 회사가 제공하는 서비스의 형태와 기능, 디자인 등은 필요한 경우 수시로 변경되거나, 중단될 수 있습니다. 회사는 이 경우 개별적인 변경에 대해서 회원에게 사전 통지하지 않습니다. 다만, 회원에게 불리한 것으로 판단되는 경우 전자우편으로 통하여 이를 공지합니다.</p>
<p>⑥ 전항에 의해서 제공되는 서비스가 변경 및 중단될 경우 무료로 제공되는 서비스에 대해서는 회원에게 별도로 보상하지 않습니다.</p>
<p>&nbsp;</p>
<p>제11조(서비스 이용의 제한)</p>
<p>① 회사는 천재지변이나 국가비상사태, 해결이 곤란한 기술적 결함 또는 서비스 운영의 심각한 변화 등 불가항력적인 경우가 발생 또는 발생이 예상될 때는 서비스의 전부 또는 일부를 예고 없이 제한하거나 중지할 수 있습니다. 서비스를 이용하게 됨으로써 서비스 영역에서 발생하는 회원 사이의 문제에 대해 회사는 책임을 지지 않습니다.</p>
<p>② 회원의 관리 소홀로 인하여 ID 및 비밀번호의 유출로 인해 회원에게 서비스 이용상의 손해가 발생하거나 제3자에 의한 부정이용 등으로 회원의 의무조항을 위반한 경우 해당 ID의 이용이 제한될 수 있습니다.</p>
<p>③ 회사는 회원이 다음 중 하나에 해당하는 경우 서비스의 이용을 정지할 수 있습니다.</p>
<ol>
<li>회원에게 발행된 고유의 스마일패스 추천코드를 회원의 고객이 아닌 이용자에게 고의로 노출하여 부당하게 보상을 취하는 경우</li>
<li>방송통신위원회ㆍ한국인터넷진흥원ㆍ과학기술정보통신부 등 관계기관이 불법스팸메시지ㆍ피싱메시지 등 불법행위의 발송사실을 확인하여 이용정지를 요청하는 경우</li>
<li>회원이 발송하는 메시지로 인하여 회사의 서비스 제공에 장애를 야기하거나 야기할 우려가 있는 경우</li>
<li>회원이 발송하는 메시지의 수신자가 스팸메시지ㆍ불법스팸메시지로 신고하는 경우 또는 확인된 경우</li>
<li>회원에게 제공하는 서비스가 스팸메시지ㆍ불법스팸메시지 발송에 이용되고 있는 경우</li>
<li>회원이 발신번호를 변작하는 등 거짓으로 표시한 경우</li>
<li>회사 서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 발송하거나 정보통신설비의 오동작 또는 시스템 보유 정보 파괴를 유발시키거나 유포하는 경우</li>
<li>에스디몰 할인쿠폰을 회원의 고객이 아닌 이용자에게 고의로 노출하여 부당하게 보상을 취하는 경우</li>
<li>기타 관련 법령 또는 이 약관에서 금지하는 행위를 하거나 회사가 정한 이용조건에 위배되는 행위를 한 경우</li>
</ol>
<p>④ 회사는 이용제한 및 정지를 하고자 하는 경우에는 그 사유, 일시 및 기간을 정하여 이용제한 및 정지에 대하여 서면 또는 전화 등의 방법에 의하여 해당 회원 또는 대리인에게 통지합니다. 다만, 긴급하게 이용을 제한 및 정지할 필요가 있다고 인정하는 경우 또는 회원의 귀책사유로 통보가 불가능한 경우, 사전통지 없이 서비스 제한 또는 정지할 수 있습니다.</p>
<p>⑤ 회원은 전 항에 따른 이용제한 및 정지에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 이용제한 및 정지 기간을 변경하거나 서비스의 이용을 재개할 수 있습니다.</p>
<p>⑥ 회사는 주민등록법을 위반한 명의도용 및 결제도용, 저작권법을 위반한 불법프로그램의 제공 및 운영방해, 정보통신망법을 위반한 스팸메시지 및 불법통신, 해킹, 악성프로그램의 배포, 접속권한 초과행위, 한국인터넷진흥원이 규정한 변작 등과 같이 관련법을 위반한 경우에는 즉시 사전 통보 없이 영구 이용정지를 할 수 있습니다. 서비스의 영구 이용정지 시에는 서비스 내의 혜택 및 권리 등도 모두 즉시 소멸되며 회사는 이에 대해 별도로 보상하지 않습니다.</p>
<p>⑦ 회원 휴면으로 인한 회사의 서비스 이용정지 및 해제와 보관방법은 다음과 같습니다.</p>
<ol>
<li>회사는 회원의 정보가 부당한 목적으로 사용되는 것을 방지하고 보다 원활한 서비스 제공을 위하여 12개월 이상 계속해서 로그인을 포함한 서비스 이용이 없는 아이디를 휴면계정으로 분류하고 서비스 이용을 정지할 수 있습니다.</li>
<li>회사는 휴면계정으로 분류되기 30일 전까지 전자우편 등으로 휴면계정으로 분류된다는 사실, 일시 및 개인정보 항목을 회원에게 통지합니다. 휴면계정으로 분류 시 개인정보는 서비스 이용중인 개인정보와 별도 분리하여 보관합니다. 개인정보 휴면 조치 등에 대한 사전통지 없이 본 조항에 의거 최종 접속 후 1년간 접속 기록이 없는 회원에 대하여 이용제한하고 개인정보를 분리보관 합니다. 보관되는 정보는 보관 외 다른 목적으로 이용되지 않으며, 관련 업무 담당자만 열람할 수 있도록 접근을 제한합니다.</li>
<li>회원은 휴면계정 보관기간 내에 로그인을 통해 휴면계정 상태를 해제할 수 있습니다.</li>
</ol>
<p>&nbsp;</p>
<p>제12조 (메시지 발송제한, 저장, 전송오류 환불)</p>
<p>① 정보통신망법에서 금지하는 대량의 불법스팸 전송을 방지하기 위하여 이용자의 아이디 당 1일 500건을 초과하는 메시지(SMS, MMS, LMS 포함) 전송을 제한할 수 있습니다. 다만, 적법한 업무용 광고 발송 등 회원 불편을 최소화하기 위하여 사전승인을 얻은 경우 발송량 제한 없이 발송 가능하도록 예외를 인정할 수 있습니다.</p>
<p>② 영리목적의 광고성 문자메세지를 보낼 때는 문자메세지 처음에 '(광고)' 의 문구가 삽입 되어야 하고 '무료수신거부','무료거부' 문구 및 080 무료전화번호를 삽입하여야 합니다.</p>
<p>③ 회사는 서비스 별로 회원이 필요에 의해 저장하고 있는 자료에 대하여 일정한 저장기간을 정할 수 있으며 필요에 따라 그 기간을 변경할 수 있습니다.</p>
<p>④ 문자 메세지 전송시 수신자 번호를 잘못 기재하여 전송처리 결과가 전송실패 된 '번호오류' 문자 또는 올바른 수신자 전화번호인데 수신자가 통신 이탈지역에 있거나 이동통신사 사정으로 문자가 성공적으로 처리되지 못해 '전송오류'가 난 경우는, 재전송하거나 환불받을 수 있습니다.</p>
<p>&nbsp;</p>
<p>제13조 (할인쿠폰)</p>
<p>① 할인쿠폰은 회사가 발행하는 쿠폰으로 ㈜에스디몰의 서비스 sdmall.com에서 사용할 수 있으며, 할인쿠폰의 세부구분, 할인금액(할인율), 사용방법, 사용기한 및 제한에 대한 사항은 할인쿠폰 또는 서비스 화면에 표시됩니다. 할인쿠폰의 종류 및 내용과 발급 여부는 회사의 서비스 정책에 따라 변경될 수 있습니다.</p>
<p>② 할인쿠폰은 현금으로 출금될 수 없으며, 할인쿠폰에 표시된 유효기간이 만료되거나 해당 서비스의 회원자격이 상실되면 소멸합니다.</p>
<p>③ 회원이 부정한 방법으로 할인쿠폰을 획득한 사실이 확인될 경우, 회사는 이를 회수하고, 회원자격 상실(아이디 삭제) 및 민&middot;형사 상의 법적 조치 등을 취할 수 있습니다.</p>
<p>&nbsp;</p>
<p>제14조 (서비스 이용의 중지 및 해지)</p>
<p>① 회원은 회사에 언제든지 이용중지를 요청하여 이용계약을 해지할 수 있으며 회사는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다. 계약을 해지할 경우 충전한 캐시는 10영업일 내 환불합니다. 단 보너스로 지급한 캐시와 파트너시스템을 통하여 적립한 N적립금은 소멸됩니다.</p>
<p>② 회사는 다음 각 호에 해당하는 회원에 대하여 사후에 이용계약을 해지할 수 있습니다.</p>
<ol>
<li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
<li>이 약관을 위반하거나 제3자에게 임의로 서비스를 임대하는 등 부정한 용도로 서비스를 사용하는 경우</li>
<li>회사의 정책에 적합하지 않는 회원으로 판단되는 경우나 서비스 제공이 곤란한 경우</li>
<li>회원의 이용 목적이나 서비스 이용 방법이 회사의 재산권이나 영업권을 침해할 우려가 있는 경우</li>
<li>방송통신위원회ㆍ한국인터넷진흥원ㆍ과학기술정보통신부 등 관계기관이 스팸메시지ㆍ피싱메시지 등 불법행위의 발송사실을 확인하여 계약해지를 요청하는 경우</li>
</ol>
<p>③ 회사는 휴면계정이 휴면상태로 1년 이상 지속될 경우 본 계약을 해지할 수 있습니다.</p>
<p>④ 회원 또는 회사가 계약을 해지할 경우 관련법 및 개인정보처리방침에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.</p>
<p>⑤ 사업종목의 전환, 사업의 포기, 업체간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는 서비스 종료 30일 전까지 서비스 홈페이지에 공지하거나 회원이 이용신청 시 등록한 이메일로 회원에게 통지한 후 서비스를 종료할 수 있습니다.</p>
<p>&nbsp;</p>
<p>제15조(책임 제한)</p>
<p>① 회사는 회원의 약관, 서비스 이용 방법 및 이용 기준을 준수하지 않는 등 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</p>
<p>② 회사는 회원이 서비스 내 또는 웹사이트상에 게시 또는 전송한 정보, 자료 등의 신뢰도, 정확성, 완결성, 품질 등 내용에 대해서 책임을 지지 않습니다.</p>
<p>③ 회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.</p>
<p>④ 회사는 천재지변, 기간통신사업자의 서비스 중지 등으로 인하여 서비스를 제공할 수 없는 경우 책임이 면제됩니다.</p>
<p>⑤ 회사는 사전에 공지된 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한 경우 책임이 면제됩니다.</p>
<p>⑥ 회원은 자신의 결정에 의해 회사의 서비스를 사용하여 특정 프로그램이나 정보 등을 다운받거나 접근함으로써 입게 되는 컴퓨터 시스템상의 손해나 데이터, 정보의 상실에 대한 책임을 집니다.</p>
<p>⑦ 회원의 컴퓨터 오류, 신상정보 및 전자우편 주소의 부정확한 기재, 비밀번호 관리의 소홀 등 회원의 귀책사유로 인해 손해가 발생한 경우 회사는 책임을 지지 않습니다.</p>
<p>⑧ 회사는 회원의 컴퓨터 환경이나 회사의 관리 범위에 있지 않은 보안 문제로 인하여 발생하는 제반 문제 또는 현재의 보안기술 수준으로 방어가 곤란한 네트워크 해킹 등 회사의 귀책사유 없이 발생하는 문제에 대해서 책임을 지지 않습니다.</p>
<p>⑨ 회사는 회원 상호간 또는 회원과 제3자 상호 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.</p>
<p>⑩ 회사는 회원이 서비스를 이용하여 기대하는 효용을 얻지 못한 것에 대하여 책임을 지지 않으며 서비스에 대한 선택 또는 이용으로 발생하는 손해 등에 대해서는 책임이 면제됩니다.</p>
<p>⑪ 회사는 회원의 게시물을 등록 전에 사전심사 하거나 상시적으로 게시물의 내용을 확인 또는 검토하여야 할 의무가 없으며, 그 결과에 대한 책임을 지지 않습니다.</p>
<p>&nbsp;</p>
<p>제16조(준거법 및 재판관할)</p>
<p>① 회사와 회원 간 제기된 소송에는 대한민국법을 준거법으로 합니다.</p>
<p>② 회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.</p>
<p>&nbsp;</p>
<p>본 약관은 2022년 3월 1일부터 적용됩니다.</p>
`;

export let POLICY_HTML = `
<ol>
<li>개인정보의 수집 및 이용목적</li>
</ol>
<p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
<p>&nbsp;</p>
<p>가. 신규 서비스의 개발</p>
<p>신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공, 접속빈도 파악, 회원의 서비스 이용에 대한 통계</p>
<p>&nbsp;</p>
<p>나. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산</p>
<p>회원제 서비스요금, SMS발송, 쿠폰발행, 협업진행</p>
<p>&nbsp;</p>
<p>다. 회원 관리</p>
<p>회원제 서비스 이용에 따른 본인확인, 개인식별, 불만처리 등 민원처리, 고지사항 전달</p>
<p>&nbsp;</p>
<p>라. 마케팅 및 광고에 활용</p>
<p>신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="2">
<li>수집하는 개인정보의 항목 및 수집방법</li>
</ol>
<p>회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
<p>&nbsp;</p>
<p>가. 수집항목</p>
<p>이름, ID, 비밀번호, 연락처, 주소, 이메일, 운동시설명</p>
<p>&nbsp;</p>
<p>나. 개인정보 수집방법</p>
<p>회사는 이용자들이 회원서비스를 이용하기 위해 서비스 신청을 할 때 서비스 제공을 위한 필수적인 정보들을 온라인 상에서 입력 받고 있습니다. 그러나 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다.</p>
<p>&nbsp;</p>
<ol start="3">
<li>개인정보의 보유 및 이용기간</li>
</ol>
<p>회사는 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.</p>
<p>&nbsp;</p>
<p>가. 회사의 내부방침에 의한 정보보유 사유</p>
<p>- 부정이용기록 : 부정이용일로부터 1년 보존</p>
<p>- 부정이용방지를 위한 탈퇴 정보 : 암호화된 전화번호 기록, 탈퇴 후 14일간 보존</p>
<p>&nbsp;</p>
<p>나. 관련법령에 의한 정보보유 사유</p>
<p>- 계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)</p>
<p>- 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)</p>
<p>- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)</p>
<p>- 방문(로그)에 관한 기록 : 3개월(통신비밀보호법)</p>
<p>&nbsp;</p>
<p>다. 회원의 개인정보</p>
<p>- 회원탈퇴시까지</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="4">
<li>개인정보의 제3자 제공</li>
</ol>
<p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 만약 회사가 이용자의 개인정보를 제3자에게 제공하게 될 경우 이용자의 별도 동의를 받은 이후 제공합니다.</p>
<p>&nbsp;</p>
<ol start="5">
<li>개인정보의 파기 절차 및 방법</li>
</ol>
<p>이용자의 개인정보는 개인정보의 수집 및 이용목적이 달성되면 지체 없이 아래와 같은 방법으로 파기합니다.</p>
<p>&nbsp;</p>
<p>가. 파기절차</p>
<p>이용자가 서비스 이용 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.</p>
<p>&nbsp;</p>
<p>나. 파기방법</p>
<p>- 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각</p>
<p>- 전자적 파일 형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="6">
<li>개인정보의 취급위탁</li>
</ol>
<p>회사는 서비스의 원활한 제공을 위해 개인정보를 위탁처리 하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.</p>
<p>현재 회사의 개인정보처리수탁자와 그 업무의 내용은 다음과 같습니다.</p>
<p>- 수탁업체 : 토스페이먼츠, 인비토, LG U+</p>
<p>- 위탁업무 내용</p>
<p>1) 토스페이먼츠 : 신용카드결제, 토스 간편결제</p>
<p>2) 인비토 : 카카오알림톡 관리</p>
<p>3) LG U+ : 문자메시지 발송</p>
<p>&nbsp;</p>
<ol start="7">
<li>이용자의 권리와 그 행사방법</li>
</ol>
<p>&nbsp;</p>
<p>가. 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 이용중지(동의철회)를 요청할 수도 있습니다.</p>
<p>&nbsp;</p>
<p>나. 이용자는 파트너시스템의 &lsquo;회원등록정보&rsquo; 페이지에서 개인정보 조회할 수 있으며, 이용중지를 원할 경우 개인정보관리 책임자에게 중지신청 또는 전화로 연락하면 지체없이 조치하겠습니다.</p>
<p>&nbsp;</p>
<p>다. 이용자가 개인정보의 오류에 대한 정정을 요청하는 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다.</p>
<p>&nbsp;</p>
<p>라. 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
<p>&nbsp;</p>
<ol start="8">
<li>쿠키(cookie)의 운영에 관한 사항</li>
</ol>
<p>회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 &lsquo;쿠키(cookie)&rsquo; 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다.</p>
<p>&nbsp;</p>
<p>가. 쿠키 등 사용 목적</p>
<p>이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 맞춤 서비스 제공</p>
<p>&nbsp;</p>
<p>나. 쿠키의 설치/운영</p>
<p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
<p>&nbsp;</p>
<p>다. 쿠키 설정 거부 방법</p>
<p>쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 이용자가 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.</p>
<p>설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="9">
<li>개인정보보호를 위한 기술적/관리적 대책</li>
</ol>
<p>&nbsp;</p>
<p>가. 회사는 이용자의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조, 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.</p>
<p>- 이용자의 개인정보는 암호화되어 보호되고 있습니다. 그러나 이용자의 개인정보를 회사가 암호화시켜 보호하고 있음에도 불구하고 이용자가 공공장소에서의 인터넷사용 등의 과정에서 의도하지 않게 분실하거나 타인에게 도난 또는 유출될 가능성이 있습니다. 그러므로 이용자는 개인정보를 타인에게 유출시키거나 대여, 제공 등 공개하여서는 아니 되며, 피싱 등 사회공학적 방법에 의한 개인정보 무단 수집으로부터 자신의 개인정보를 책임 있게 관리하여야 합니다. 이러한 개인정보의 분실, 도난 유출, 피싱, 공개에 대해서 회사는 어떠한 책임도 지지 않습니다.</p>
<p>- 이용자의 개인정보는 기본적으로 비밀번호에 의해 보호되며, 파일 및 전송 데이터를 암호화하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.</p>
<p>- 회사는 암호알고리즘을 이용하여 네트워크상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.</p>
<p>- 회사는 해킹 등 회사 정보통신망 침입에 의해 이용자의 개인정보가 유출되는 것을 방지하기 위해 외부로부터의 침입탐지 및 침입차단 시스템을 24시간 가동하고 있습니다.</p>
<p>&nbsp;</p>
<p>나. 회사는 이용자의 개인정보보호의 중요성을 인식하고 있으며 이용자의 개인정보보호를 위해 개인정보취급직원을 최소한으로 제한하는 등 다음과 같은 관리적 조치를 취하고 있습니다.</p>
<p>- 개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보보호의무 등에 관해 정기적인 사내교육 및 외부 위탁교육을 실시하고 있습니다.</p>
<p>- 회사는 모든 입사자에게 보안서약서를 제출케 함으로 사람에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수여부를 감시하고 위반내용이 확인되는 경우 이를 시정 또는 개선하고 기타 필요한 조치를 취하기 위한 내부절차를 마련하고 있습니다. 개인정보 관련 취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사/퇴사 후 개인정보 사고에 대한 책임을 명확화하고 있습니다.</p>
<p>- 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 이용자 개개인이 본인의 개인정보를 보호하기 위해서 자신의 아이디(ID) 와 비밀번호를 적절하게 관리하고 이에 대한 책임을 져야 합니다.</p>
<p>&nbsp;</p>
<ol start="10">
<li>개인정보보호책임자</li>
</ol>
<p>회사는 이용자가 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 개인정보를 보호하는데 있어 이용자에게 고지한 사항들에 반하는 사고가 발생할 시에는 회사가 모든 책임을 집니다. 그러나 기술적인 보완조치를 했음에도 불구하고, 해킹 등 기본적인 네트워크상의 위험성에 의해 발생하는 예기치 못한 사고로 인한 정보의 훼손 및 방문자가 작성한 게시물에 의한 각종 분쟁에 관해서 회사는 책임을 지지 않습니다. 이용자의 개인정보를 취급하는 책임자는 다음과 같으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해 드리고 있습니다.</p>
<p>&nbsp;</p>
<p>개인정보보호책임자 성명 : 김종만</p>
<p>전화번호　: 070-4480-9339</p>
<p>이메일　: <a href="mailto:sp@smilepass.co.kr"><u>sp@smilepass.co.kr</u></a></p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="11">
<li>개인정보에 관한 민원서비스</li>
</ol>
<p>회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 개인정보보호민원 담당부서를 지정하여 운영하고 있습니다.</p>
<p>&nbsp;</p>
<p>개인정보보호 담당부서 : 에스디네트웍스팀</p>
<p>전화번호 : 070-4480-9337</p>
<p>이메일　: sp@smilepass.co.kr</p>
<p>&nbsp;</p>
<p>이용자는 회사의 서비스를 이용하며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고할 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다. 기타 개인정보침해에 대한 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</p>
<p>&nbsp;</p>
<p>- 개인정보침해신고센터</p>
<p>TEL : 국번없이 118</p>
<p>URL : http://privacy.kisa.or.kr</p>
<p>&nbsp;</p>
<p>- 대검찰청 사이버 수사과</p>
<p>TEL : 국번없이 1301</p>
<p>URL : www.spo.go.kr</p>
<p>&nbsp;</p>
<p>- 경찰청 사이버 안전국</p>
<p>TEL : 국번없이 182</p>
<p>URL : cyberbureau.police.go.kr</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="12">
<li>고지의 의무</li>
</ol>
<p>&nbsp;</p>
<p>가. 본 개인정보처리방침을 포함한 기타 개인정보보호에 대한 상세한 내용은 서비스 홈페이지 첫 화면에 공개함으로써 이용자가 언제나 용이하게 보실 수 있도록 조치하고 있습니다.</p>
<p>&nbsp;</p>
<p>나. 법령 정책 또는 보안기술의 변경에 따라 중요한 내용의 추가 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 시행하기 7일 전에 서비스 홈페이지를 통해 변경이유 및 내용 등에 대하여 공지하도록 하겠습니다.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>부칙</p>
<ol>
<li>본 처리방침은 2022년 3월1일부터 시행됩니다.</li>
</ol>
`;